import React from 'react';
import times from 'lodash/times';
import {
  NetWorthTableGroupHeader,
  NetWorthTableHeader,
  NetWorthTableLabelCell,
  NetWorthTableRow,
  NetWorthTableValueCell,
  StyledNetWorthTable,
} from './NetWorthTableStyles';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';

const categories = ['Investment Assets', 'Other Assets', 'Liabilities'];

interface Props {}

export const NetWorthTableLoading: React.FC<Props> = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <StyledNetWorthTable>
      <NetWorthTableHeader>
        <NetWorthTableLabelCell style={{ fontWeight: 600 }}>Description</NetWorthTableLabelCell>
        <NetWorthTableValueCell style={{ fontWeight: 600 }}>Total</NetWorthTableValueCell>
      </NetWorthTableHeader>
      {categories.map(category => (
        <React.Fragment key={category}>
          <NetWorthTableGroupHeader color="#333">{category}</NetWorthTableGroupHeader>
          {times(2).map(key2 => (
            <NetWorthTableRow key={key2}>
              <NetWorthTableLabelCell>
                <Shimmer
                  width={isEmbeddedMobile ? '200px' : '300px'}
                  height="14px"
                  style={{ marginTop: 4 }}
                />
              </NetWorthTableLabelCell>
              <NetWorthTableValueCell>
                <Shimmer
                  width={isEmbeddedMobile ? '75px' : '100px'}
                  height="14px"
                  style={{ marginTop: 4 }}
                />
              </NetWorthTableValueCell>
            </NetWorthTableRow>
          ))}
          <NetWorthTableRow>
            <NetWorthTableLabelCell style={{ fontWeight: 600 }}>Total</NetWorthTableLabelCell>
            <NetWorthTableValueCell>
              <Shimmer
                width={isEmbeddedMobile ? '75px' : '100px'}
                height="14px"
                style={{ marginTop: 4 }}
              />
            </NetWorthTableValueCell>
          </NetWorthTableRow>
        </React.Fragment>
      ))}
      <NetWorthTableGroupHeader color="#333">
        <NetWorthTableRow>
          <NetWorthTableLabelCell style={{ fontWeight: 700, padding: 0 }}>
            Net Worth
          </NetWorthTableLabelCell>
          <NetWorthTableValueCell style={{ fontWeight: 700, padding: 0 }}>
            <Shimmer
              width={isEmbeddedMobile ? '75px' : '100px'}
              height="14px"
              style={{ marginTop: 4 }}
            />
          </NetWorthTableValueCell>
        </NetWorthTableRow>
      </NetWorthTableGroupHeader>
    </StyledNetWorthTable>
  );
};
